import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import {
  ErrorModel,
  GlobalMessageService,
  GlobalMessageType,
  HttpResponseStatus,
  InternalServerErrorHandler
} from '@spartacus/core'
import { HttpErrorResponse, HttpRequest } from '@angular/common/http'
import { Router } from '@angular/router'
import { MbSpinnerService } from '../../../../shared/services/mb-spinner.service'

@Injectable({
  providedIn: 'root',
})
export class MbInternalServerErrorHandler extends InternalServerErrorHandler {
  responseStatus = HttpResponseStatus.INTERNAL_SERVER_ERROR

  constructor (protected globalMessageService: GlobalMessageService,
               @Inject(PLATFORM_ID) protected platformId?: Object,
               protected router?: Router,
               protected mbSpinnerService?: MbSpinnerService) {
    super(globalMessageService, platformId)
  }

  handleError (request?: HttpRequest<any>, response?: HttpErrorResponse) {
    this.getErrors(response)
      .forEach((error: ErrorModel) => {
        if (!(this.handleOrderNotFoundError(error) || this.handleSearchTermLimitExceededError(error))) {
          // handle error methods must return true in order to avoid rendering the error banner from below
          this.globalMessageService.add(
            { key: 'httpHandlers.internalServerError' },
            GlobalMessageType.MSG_TYPE_ERROR
          )
        }
      })
  }

  handleOrderNotFoundError (error: any) {
    return error?.type === 'OrderNotFoundError' ? this.router?.navigateByUrl('/not-found') : false
  }

  handleSearchTermLimitExceededError (error: any) {
    if (error?.type === 'SearchTermLimitExceeded') {
      this.mbSpinnerService?.clearMbSpinner()
      this.router?.navigateByUrl('/')
      return true
    } else {
      return false
    }
  }

  protected getErrors (response?: HttpErrorResponse) {
    return (response?.error?.errors || [])
      .filter((error: ErrorModel) => (error.type !== 'JaloObjectNoLongerValidError'))
      // don't show the user Cart not found error MBCOM-4166
      .filter((error: ErrorModel) => !(error?.type === 'CartError' && error?.reason === 'notFound'))
  }
}
